const IMAGES = [
    require("./bar_22_q1.webp"),
    require("./bar_22_q3.webp"),
    require("./bar_23_q1.webp"),
    require("./bar_23_q3.webp"),
    require("./bar_22_q2.webp"),
    require("./bar_22_q4.webp"),
    require("./bar_23_q2.webp"),
]

export default IMAGES;
